<template>
  <v-container class="pa-0">
    <v-toolbar flat>
      <v-toolbar-title>Bookings</v-toolbar-title>

      <v-spacer />
    </v-toolbar>
    <v-divider />

    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="items"
      :loading="isLoading"
      :loading-text="'Loading bookings...'"
      hide-default-footer
    >
      <template v-if="!isLoading" v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.name">
            <td>
              <div>{{ getTitle(item.startAt) }}</div>
              <div class="caption grey--text">{{ item.product.label }}</div>
            </td>
            <td>
              <booking-status-chip
                :booking="item"
              />
            </td>
            <!-- <td>
              <invoice-status-chip
                :invoice="item.invoice"
              />
              <v-icon
                small
                right
                @click="$router.push({ name: 'invoice-detail', params: { id: item.invoice.id } })"
              >
                launch
              </v-icon>
            </td> -->
            <td class="text-right">

              <v-menu
                v-if="!item.default_for_currency"
                left
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <cancel-booking-dialog
                    :id="item.id"
                    @action="onCancelAction"
                  >
                    <template v-slot:activator="{ on }">
                      <v-list-item v-on="on">
                        <v-list-item-content>
                          <v-list-item-title class="error--text">
                            <v-icon small left color="error">cancel</v-icon>
                            Cancel Booking
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </cancel-booking-dialog>
                </v-list>
              </v-menu>

            </td>
          </tr>
        </tbody>
      </template>

      <template v-slot:footer="{}">
        <v-divider/>
        <v-layout>
          <span/>
          <v-spacer/>
          <v-btn
            icon
            :disabled="isLoading || disablePrev()"
            @click="prevPage()"
          >
            <v-icon>navigate_before</v-icon>
          </v-btn>
          <v-btn
            icon
            :disabled="isLoading || disableNext()"
            @click="nextPage()"
          >
            <v-icon>navigate_next</v-icon>
          </v-btn>
        </v-layout>
      </template>
    </v-data-table>

  </v-container>
</template>
<script>
import { get, isEmpty } from 'lodash'
import { unixDateDiff, convertTimestampToDate } from "../../services/util.service"

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import InvoiceStatusChip from "../Invoice/InvoiceStatusChip"
import BookingStatusChip from "../Bookings/BookingStatusChip"
import CancelBookingDialog from "../Bookings/CancelBookingDialog"

export default {
  components: {
    CancelBookingDialog,
    BookingStatusChip,
    InvoiceStatusChip
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([ 'getCustomerBookings' ]),
    onCancelAction() {
      this.reloadPage()
    },
    getTitle(startAt) {
      return moment(convertTimestampToDate(startAt)).format('LLLL')
    },
    disablePrev() {
      return false //isEmpty(this.endBefore)
    },
    disableNext() {
      return false //isEmpty(this.startAfter)
    },
    reloadPage() {
      const firstItemId = get(this.items, '[0].id')

      if (!isEmpty(firstItemId)) {
        this.items = []
        this.isLoading = true
        const payload = {
          id: this.id,
          pagination: {
            limit: this.limit,
            startAt: firstItemId
          },
          expand: ['product', 'invoice']
        }

        this.getCustomerBookings(payload)
          .then(res => {
            const { data } = res
            this.items = [ ...data ]
          })
          .finally(() => {
            this.isLoading = false
          })
      }

    },
    nextPage() {
      this.isLoading = true

      const payload = {
        id: this.id,
        pagination: {
          limit: this.limit,
          startAfter: this.startAfter,
          startAt: this.startAt
        },
        expand: ['product', 'invoice']
      }

      this.getCustomerBookings(payload)
        .then(res => {
          const { data } = res
          this.items = [ ...data ]

          if (data.length > 0) {
            this.endBefore = get(data, '[0].id')
            this.startAfter = get(data, `[${data.length - 1}].id`)
          } else {
            this.endAt = this.startAfter
            this.endBefore = null
            this.startAfter = null
          }

        })
        .finally(() => {
          this.isLoading = false
        })
    },
    prevPage() {
      this.isLoading = true

      const payload = {
        id: this.id,
        pagination: {
          limitToLast: this.limit,
          endBefore: this.endBefore,
          endAt: this.endAt
        },
        expand: ['product', 'invoice']
      }

      this.getCustomerBookings(payload)
        .then(res => {
          const { data } = res
          this.items = [ ...data ]

          if (data.length > 0) {
            this.endBefore = get(data, '[0].id')
            this.startAfter = get(data, `[${data.length - 1}].id`)
          } else {
            this.startAt = this.endBefore
            this.startAfter = null
            this.endBefore = null
          }

        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  data() {
    return {
      isLoading: false,
      items: [],
      limit: 10,
      endBefore: null,
      startAfter: null,
      headers: [
        {
          text: 'Date & Product',
          align: 'start',
          sortable: false,
        },
        {
          text: 'Booking Status',
          sortable: false
        },
        // {
        //   text: 'Invoice Status',
        //   sortable: false,
        // },
        {
          text: 'Actions',
          align: 'right',
          sortable: false,
        },
      ]
    }
  },
  mounted() {
    this.nextPage()
  }
}
</script>
